<template>
  <div class="panel panel-default" style="border: none;">
    <div class="form-group" v-if="!localProduct">
      <select-product-autocomplete></select-product-autocomplete>
    </div>
    <div class="form-control" v-if="localProduct">
        <input type="hidden" name="product_id" :value="localProduct.id">
        <a :href="localProductUrl" target="_blank" v-text="localProduct.name"></a>
        <a @click="remove()" class="btn btn-primary btn-danger btn-xs b-remove-pack__button remove-btn" style="float: right;">
          <i class="fa fa-ban"></i>
        </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "review",
  props: {
    product: Object,
    product_url: String,
  },
  data () {
    return {
      localProduct: this.product,
      localProductUrl: this.product_url
    }
  },
  created() {
    this.$root.$on('select-product-autocomplete:product_selected', this.onProductSelected);
  },
  methods: {
    onProductSelected(product) {
      this.localProduct = product;
    },
    remove() {
      this.localProduct = null;
    },
  },
}
</script>
